import { render, staticRenderFns } from "./DashboardBodyTemplate.vue?vue&type=template&id=75533db4&scoped=true"
import script from "./DashboardBodyTemplate.vue?vue&type=script&lang=js"
export * from "./DashboardBodyTemplate.vue?vue&type=script&lang=js"
import style0 from "./DashboardBodyTemplate.vue?vue&type=style&index=0&id=75533db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75533db4",
  null
  
)

export default component.exports